<td class="wrapper">
    <div class="item">Item</div>
    <div class="item">Price</div>
    <div class="item">Quantity</div>
    <div class="item">Total</div>
</td>
